export default __webpack_public_path__ + "static/media/bills.604e7d43.svg";